import { Input, Checkbox } from "@/components/Inputs";
import {
    name,
    cardsImage,
    applepayImage,
    googlepayImage,
    defaultTips,
    worldMapImage,
    cardChipImage,
} from "@/constants";
import { useState } from "react";
import Cart from "../../components/Cart";
import { useTip } from "../../hooks/useTip";
import axios from "axios";
import useCart from "../../hooks/useCart";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useCreditCardValidator, images } from "react-creditcard-validator";
import { motion } from "framer-motion";
import { useAuthModal } from "@/components/AuthModal";
import { useParams } from "react-router-dom";
import useAuth from "@/hooks/useAuth";

const Index = ({ setOrderPlaced }) => {
    const { businessName } = useParams();
    const { cart: cartItems, clearCart } = useCart();
    const { openAuthModal } = useAuthModal();
    const { user } = useAuth();

    const getCurrentMMYY = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear().toString().slice(-2);
        const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
        return `${month}${year}`;
    };

    const [cardFront, setCardFront] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);
    const [token, setToken] = useState("");
    const [fname, setFname] = useState("");
    const [lname, setLname] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [country, setCountry] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [vatAmount, setVatAmount] = useState("");
    const [tipNumber, setTipNumber] = useTip();
    const [card, setCard] = useState({ number: null, cvv: null, exp: null });
    const [cardName, setCardName] = useState("");
    const [subTotal, setSubTotal] = useState("");

    useEffect(() => {
        setSubTotal(
            cartItems
                .reduce((accumulator, object) => {
                    return accumulator + parseFloat(object.price) * object.qty;
                }, 0)
                .toFixed(2)
        );
    }, [cartItems]);

    useEffect(() => {
        if (!vatAmount) {
            const fetchData = async () => {
                try {
                    const response = await axios.get(
                        process.env.REACT_APP_API_URL +
                            "/OnlineOrdering/GetVatData?BusinessName=FoodB_" +
                            businessName.toLocaleLowerCase()
                    );
                    setVatAmount(parseFloat(response.data.data[0].amount).toFixed(2));
                } catch (error) {
                    console.error(error);
                }
            };
            fetchData();
        }
        if (!user) {
            openAuthModal();
        }
        if (user) {
            setFname(fname || user.data.fname);
            setLname(lname || user.data.lname);
            setPhone(phone || user.data.phone);
            setEmail(email || user.data.email);
        }
    }, [user]);

    useEffect(() => {
        if (window.CollectJS) {
            window.CollectJS.configure({
                variant: "inline",
                styleSniffer: true,
                callback: (token) => {
                    setToken(token.token);
                },
                invalidCss: {
                    "border-color": "#fca5a5",
                },
                customCss: {
                    "border-radius": "4px",
                    padding: "22px 12px",
                    border: "solid #cfcccc 1.5px",
                },
                fields: {
                    ccnumber: {
                        placeholder: "0000 0000 0000 0000",
                        selector: "#ccnumber",
                    },
                    ccexp: {
                        placeholder: "MM/YYYY",
                        selector: "#ccexp",
                    },
                    cvv: {
                        placeholder: "CVV",
                        selector: "#cvv",
                    },
                },
            });
        }
    }, []);

    useEffect(() => {
        if (token) onPayment();
    }, [token]);

    const onPayment = async () => {
        if (!user) {
            toast.error("Please Login First");
            return openAuthModal();
        }
        if (cartItems.length <= 0) return toast.error("Cart is empty");
        else if (!fname || !lname) return toast.error("First or Last name Missing");
        else if (!email) return toast.error("Email is required");
        else if (!phone) return toast.error("Phone is required");
        else if (!address) return toast.error("Address is required");
        else if (!city) return toast.error("City is required");
        else if (!country) return toast.error("Country is required");
        else if (!postalCode) return toast.error("Postal Code is required");
        else if (erroredInputs.cardNumber) return toast.error("incorrect card number");
        else if (erroredInputs.expiryDate) return toast.error("incorrect exp date");
        else if (erroredInputs.cvc) return toast.error("cvc is incorrect");

        const convertedCartItems = cartItems.map((item) => {
            return {
                ItemId: item.id,
                ItemName: item.productName,
                ItemQuantity: item.qty,
                ItemOriginalPrice: item.price,
                vatAmount,
                Extras: [],
                MealOptions: [],
                ItemPrice: item.price,
            };
        });
        const totalPrice = (parseFloat(subTotal) + parseFloat(tipNumber)).toFixed(2);
        const formData = new URLSearchParams();
        formData.append("UserName", fname + " " + lname);
        formData.append("BusinessName", `FoodB_${businessName}`);
        formData.append("CustomerId", user.data.userId);
        formData.append(
            "OrdersJsonData",
            JSON.stringify({
                Cart_data: convertedCartItems,
                paymentToken: token,
                OrderType: "eatin",
                PaymentType: "card",
                OrderStatus: "inprogressunpaid",
                TableName: "",
                TableId: 0,
                orderNumber: "",
                tip: tipNumber,
                Total_Price: totalPrice,
                CustomerName: `${fname} ${lname}`,
                firstName: fname,
                lastName: lname,
                address,
                zipcode: postalCode,
                city,
                state: country,
                Email: email,
                CustomerNumber: phone,
            })
        );

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL + "/OnlineOrdering/WebOrderDataSubmit",
                formData
            );
            if (response?.data?.code === 201) {
                toast.success(response?.data?.description || "order placed");
                clearCart();
                setTipNumber("0");
                setOrderPlaced(response?.data || false);
            } else {
                toast.error(toast?.description || "Transaction Unsuccessfull");
            }
        } catch (error) {
            toast.error("failed to place order");
        } finally {
            setToken("");
            setIsProcessing(false);
        }
    };

    const {
        getCardNumberProps,
        getCardImageProps,
        getCVCProps,
        getExpiryDateProps,
        meta: { erroredInputs },
    } = useCreditCardValidator();

    return (
        <div className="pb-6 md:pb-20 flex flex-col-reverse md:flex-row justify-center items-start padding-x">
            <section className="w-full md:w-2/3 md:mr-5">
                <form>
                    <h1 className="pb-10 font-bold text-xl md:text-2xl lg:text-3xl">{businessName}</h1>
                    <div className="flex justify-evenly px-4 py-2 rounded-lg text-sm w-full bg-white text-gray-500">
                        <a className="p-1 px-2 rounded hover:text-white hover:bg-primary" href="#contact">
                            Contact
                        </a>
                        <a className="p-1 px-2 rounded hover:text-white hover:bg-primary" href="#tip">
                            Tip
                        </a>
                        <a className="p-1 px-2 rounded hover:text-white hover:bg-primary" href="#pay">
                            Pay
                        </a>
                    </div>
                    <br />
                    <div id="contact" className="flex flex-wrap p-2 rounded-lg bg-white">
                        <p className="w-full p-2">Contact information</p>
                        <Input
                            value={fname}
                            onChange={(e) => setFname(e.target.value)}
                            width="w-1/2"
                            type="text"
                            placeholder="First name"
                        />
                        <Input
                            value={lname}
                            onChange={(e) => setLname(e.target.value)}
                            width="w-1/2"
                            type="text"
                            placeholder="Last name"
                        />
                        <Input
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            type="number"
                            placeholder="Mobile number"
                        />
                        <Input
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            placeholder="Email address"
                        />
                        <Input
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            type="address"
                            placeholder="Address"
                        />
                        <Input value={city} onChange={(e) => setCity(e.target.value)} type="city" placeholder="City" />
                        <Input
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                            width="w-1/2"
                            type="country"
                            placeholder="Country"
                        />
                        <Input
                            value={postalCode}
                            onChange={(e) => setPostalCode(e.target.value)}
                            width="w-1/2"
                            type="postalCode"
                            placeholder="PostalCode"
                        />
                        <Checkbox
                            checked={true}
                            label="Save my details to keep up to date on news and special offers"
                        />
                    </div>
                    <br />
                    <div id="tip" className="flex flex-wrap p-2 rounded-lg bg-white">
                        <p className="w-full p-2">Add tip</p>
                        <div className="flex justify-center w-full border border-shade-dark rounded overflow-hidden m-2">
                            {defaultTips.map((item, index) => (
                                <div
                                    className={`${index === 0 ? "" : "border-l"} ${
                                        item.value == tipNumber ? "bg-primary text-white" : ""
                                    } flex-1 text-center text-lg font-light p-5 text-gray-500 border-shade-dark cursor-pointer hover:bg-primary hover:text-white`}
                                    key={index}
                                    onClick={() => setTipNumber(item.value)}
                                >
                                    {item.name}
                                </div>
                            ))}
                        </div>
                        <Input
                            value={tipNumber}
                            onChange={(e) => setTipNumber(e.target.value)}
                            type="number"
                            placeholder="Custom tip"
                        />
                    </div>
                    <br />
                    <div id="pay" className="flex flex-wrap p-4  rounded-lg bg-white">
                        <p className="w-full p-2">Payment</p>
                        <div className={`w-full relative p-2`}>
                            <label className={`top-2 text-[10px] absolute left-4 text-shade-dark`}>Card Number</label>
                            <div id="ccnumber" />
                        </div>
                        <div className={`w-1/2 relative p-2`}>
                            <label className={`top-2 text-[10px] absolute left-4 text-shade-dark`}>
                                Expiration Date
                            </label>
                            <div id="ccexp" />
                        </div>
                        <div className={`w-1/2 relative p-2`}>
                            <label className={`top-2 text-[10px] absolute left-4 text-shade-dark`}>Cvv</label>
                            <div id="cvv" />
                        </div>

                        {/* <div className="flex items-center rounded border-l-4 cursor-pointer p-2 m-2 w-full border-primary bg-shade-light ">
                            <img className="w-8" src={`../${cardsImage}`} alt="cards image" />
                            <p className="pl-2 text-sm font-light">Debit / Credit card</p>
                        </div>
                        <div className="relative h-40 m-2 w-full flex justify-center items-center">
                            <motion.div
                                initial={{ scale: 1, rotateY: 0 }}
                                animate={!cardFront ? { scale: 1.2, rotateY: 90 } : { scale: 1, rotateY: 0 }}
                                transition={{
                                    type: "just",
                                    duration: 0.2,
                                    delay: cardFront ? 0.2 : 0,
                                }}
                                className="absolute p-2 pt-14 gap-4 overflow-hidden flex flex-col justify-center items-center bg-secondary text-white rounded w-72 h-40"
                            >
                                <img
                                    className="absolute top-0 left-0 opacity-10 scale-150 w-full h-auto"
                                    src={`../${worldMapImage}`}
                                    alt=" "
                                />
                                <img className="absolute top-6 left-6 w-10 h-auto" src={cardChipImage} alt=" " />
                                <svg
                                    className="absolute top-6 right-6 origin-top w-10 h-7"
                                    {...getCardImageProps({ images })}
                                />
                                <span className="text-lg">{card.number || "0000 0000 0000 0000"}</span>
                                <div className="text-sm px-4 flex justify-between w-full">
                                    <span>EXP : {card.exp || "MM/YY"}</span>
                                    <span className="w-32 text-end whitespace-nowrap overflow-hidden">
                                        {cardName || "Name"}
                                    </span>
                                </div>
                            </motion.div>
                            <motion.div
                                initial={{ scale: 1.2, rotateY: 90 }}
                                animate={!cardFront ? { scale: 1, rotateY: 0 } : { scale: 1.2, rotateY: 90 }}
                                transition={{
                                    type: "just",
                                    duration: 0.2,
                                    delay: cardFront ? 0 : 0.2,
                                }}
                                className="absolute gap-5 flex flex-col overflow-hidden justify-center items-center bg-secondary text-white rounded w-72 h-40"
                            >
                                <img
                                    className="absolute top-0 left-0 -scale-x-150 opacity-10 scale-150 w-full h-auto"
                                    src={`../${worldMapImage}`}
                                    alt=" "
                                />
                                <div className="relative z-10 bg-gray-300 w-full h-10" />
                                <span>{card.cvv || "000"}</span>
                            </motion.div>
                        </div>

                        <div className={`w-full relative p-2`}>
                            <label className={`top-2 text-[10px] absolute left-4 text-shade-dark`}>Card Number</label>
                            <input
                                {...getCardNumberProps({
                                    onChange: (e) => setCard((prev) => ({ ...prev, number: e.target.value })),
                                    onFocus: () => setCardFront(true),
                                })}
                                className={`relative w-full outline-none rounded p-2 py-3 border ${
                                    erroredInputs.cardNumber ? "border-red-300" : "border-shade-dark"
                                } bg-transparent`}
                            />
                            <svg
                                className="absolute scale-125 sm:scale-150 origin-right right-5 top-1/2 -translate-y-1/2"
                                {...getCardImageProps({ images })}
                            />
                        </div>
                        <div className={`w-1/2 relative p-2`}>
                            <label className={`top-2 text-[10px] absolute left-4 text-shade-dark`}>MM/YY</label>
                            <input
                                {...getExpiryDateProps({
                                    onChange: (e) =>
                                        setCard((prev) => ({
                                            ...prev,
                                            exp: String(e.target.value),
                                        })),
                                    onFocus: () => setCardFront(true),
                                })}
                                className={`relative w-full outline-none rounded p-2 py-3 border 
                                ${erroredInputs.expiryDate ? "border-red-300" : "border-shade-dark"}
                                bg-transparent`}
                            />
                        </div>
                        <div className={`w-1/2 relative p-2`}>
                            <label className={`top-2 text-[10px] absolute left-4 text-shade-dark`}>CVV</label>
                            <input
                                {...getCVCProps({
                                    onChange: (e) => setCard((prev) => ({ ...prev, cvv: e.target.value })),
                                    onFocus: () => setCardFront(false),
                                })}
                                className={`relative w-full outline-none rounded p-2 py-3 border 
                                ${erroredInputs.cvc ? "border-red-300" : "border-shade-dark"}
                                bg-transparent`}
                            />
                        </div>
                        <Input
                            value={cardName}
                            onChange={(e) => setCardName(e.target.value)}
                            onFocus={() => setCardFront(true)}
                            type="text"
                            placeholder="Name on card"
                        /> */}
                        <Checkbox checked={false} label="Save details for future payments" />
                        <div className="flex items-center rounded border-l-4 cursor-pointer p-2 m-2 w-full  bg-shade-light ">
                            <div className="bg-white border border-black rounded-full py-1 px-2">
                                <img
                                    className="object-cover object-center h-4 w-8"
                                    src={`../${googlepayImage}`}
                                    alt="cards image"
                                />
                            </div>
                            <p className="pl-2 text-sm font-light">Google pay</p>
                        </div>
                        <div className="flex items-center rounded border-l-4 cursor-pointer p-2 m-2 w-full bg-shade-light ">
                            <div className="bg-white border border-black py-1 px-2">
                                <img
                                    className="object-cover object-center h-4 w-8"
                                    src={`../${applepayImage}`}
                                    alt="cards image"
                                />
                            </div>
                            <p className="pl-2 text-sm font-light">Apple pay</p>
                        </div>
                    </div>
                    <button
                        onClick={() => setIsProcessing(true)}
                        id="payButton"
                        type="submit"
                        disabled={isProcessing}
                        className="bg-primary hover:bg-secondary text-white rounded-lg p-2 my-6 w-full font-semibold text-center"
                    >
                        {isProcessing ? "Processing" : "Pay now"}
                    </button>
                </form>
            </section>
            <section className="flex flex-col justify-between h-[70vh] relative md:sticky top-10 w-full md:w-1/3 md:ml-5 p-2 rounded-lg bg-white">
                <Cart />
            </section>
        </div>
    );
};

export default Index;
